export enum SidebarGroup {
  Sparck = 'sparck',
  General = 'general',
  Management = 'management',
  Content = 'content',
  Others = 'others',
}
